import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as _ from "lodash";
import { moment } from "ngx-bootstrap/chronos/test/chain";
import { Observable } from "rxjs/Observable";
import { TAAConstants } from "../../../../views/constants/taa-constants";
import { AppService } from "../../../../views/services/app.service";
import { CommonService } from "../../../../views/services/common.service";
import { DocumentService } from "../../../../views/services/document.service";
import { HeaderService } from "../../../../views/services/header.service";
import { RequestSubmitService } from "../../../../views/services/requestsubmit.service";
import { User } from "../../../../views/services/user.model";
import { InternalReviewData } from "../../../../views/shared/models/review-data";
import { ConsultantsService } from "../../accmgr/services/consultants.service";
import { PersonRequestService } from "./../../accmgr/services/person-request-service";

@Component({
  templateUrl: "./examinee-request-details.component.html"
})
export class ExamineeAccRequestDetailsComponent implements OnInit, OnDestroy {
  public personId: string;
  public requestId: string;
  public userProfile: User;
  internalReviewData: InternalReviewData = {};
  public studentDetails: any;
  public currentRecord: any;
  public testDateId: any;
  public testId: any;
  public isLoading: boolean = false;
  public testDates: any;
  public optedAssociatedDates: any;
  public personPlanId: any;
  public disPlan: boolean = false;
  public displayPlanName: boolean = false;
  public supReason: boolean = false;
  public autoApprovalRequestObj = {
    disabilities: [],
    documents: [],
    planLength: "",
    accomsList: [],
    personId: "",
    requestId: ""
  };
  public reqAccoms: any;
  public documentList: any;
  public diagId: any;
  public commentList: any;
  public requestStatusCode: any;
  public statusCd: any;
  public consultantId: any;
  public consultantDetails: any;
  public commentText: any;
  public viewComment = true;
  public commentTextError: boolean = false;
  public reviewDetailId: any;
  public status_cd: any;
  public requestStatusId: any;
  public reviewDetails: any;
  public reviewConsultantDetails: any;
  public logDetails: any;
  public logId: any;
  public date: any;
  public msart1041: boolean = false;

  constructor(
    private appService: AppService,
    public commonService: CommonService,
    public documentService: DocumentService,
    private analystsService: ConsultantsService,
    public taaConstants: TAAConstants,
    public requestSubmitService: RequestSubmitService,
    public personRequestService: PersonRequestService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    public headerService: HeaderService
  ) {}
  ngOnInit() {
    window.scrollTo(0, 0);
    this.autoApprovalRequestObj.planLength = "";
    if (sessionStorage.getItem("internalStudentDetails")) {
      const studentDetails: any = JSON.parse(
        sessionStorage.getItem("internalStudentDetails")
      );
      this.personId = studentDetails.personId;
      this.requestId = studentDetails.requestId;
      this.internalReviewData.displayAccomsList = [];
      this.internalReviewData.documentDisplayList = [];
      this.internalReviewData.disabilityCategory = [];
      this.internalReviewData.actId = "";
      this.internalReviewData.extPersonId = "";
      this.internalReviewData.dateOfBirth = "";
      this.internalReviewData.stateStudentId = "";
      this.internalReviewData.taaPin = "";
      this.internalReviewData.firstNm = "";
      this.internalReviewData.middleNm = "";
      this.internalReviewData.lastNm = "";
      this.internalReviewData.address1 = "";
      this.internalReviewData.address2 = "";
      this.internalReviewData.city = "";
      this.internalReviewData.state = "";
      this.internalReviewData.zip = "";
      this.internalReviewData.country = "";
      this.consultantId = studentDetails.consultantId;
      this.reviewDetailId = studentDetails.reviewDetailId;
      this.buildForm();
    }
    this.appService.getUserProfile().then(user => (this.userProfile = user));
    this.headerService
      .getConfigPropertyValue("msart_1041")
      .subscribe((resp: any) => {
        if (resp.body === true) {
          this.msart1041 = true;
        }
      });
  }

  ngOnDestroy() {}

  buildForm() {
    Observable.forkJoin([
      this.personRequestService.getPersonById(this.personId),
      this.personRequestService.getPersonNameById(this.personId),
      this.personRequestService.getPersonAddressById(this.personId),
      this.personRequestService.getPersonDocumentById(this.personId),
      this.personRequestService.getPersonDisabilityById(this.personId),
      this.personRequestService.getPersonPlanById(this.personId),
      this.personRequestService.getPersonTestById(this.personId),
      this.personRequestService.getReqAccomsById(this.requestId),
      this.personRequestService.getRequestCommentsById(this.requestId),
      this.personRequestService.getPersonRequestForDisplay(this.requestId),
      this.personRequestService.getPersonTestAdmin(this.personId),
      this.analystsService.getConsultantDetailsById(this.consultantId),
      this.personRequestService.getReviewDetailId(this.personId),
      this.personRequestService.getAccomDetails(this.requestId),
      this.personRequestService.getLogDetails(this.personId, this.requestId)
    ]).subscribe(
      ([
        person,
        personName,
        personAddress,
        personDocument,
        personDisability,
        personPlan,
        personTest,
        accommodation,
        requestCommentData,
        request,
        personTestAdmin,
        consultantDetails,
        reviewDetailId,
        accommsDetails,
        logId
      ]) => {
        this.internalReviewData.actId = person[0].ACT_ID;
        this.internalReviewData.extPersonId = person[0].EXT_PERSON_ID;
        this.date = person[0].BIRTH_DT.split("T")[0];
        this.internalReviewData.dateOfBirth = moment(
          this.date,
          "YYYY-MM-DD"
        ).format("MM/DD/YYYY");
        this.internalReviewData.stateStudentId = person[0].STATE_SYSTEM_ID;
        this.internalReviewData.taaPin = person[0].ACCOMMS_PIN;
        this.internalReviewData.firstNm = personName[0].FIRST_NM;
        this.internalReviewData.middleNm = personName[0].MIDDLE_NM;
        this.internalReviewData.lastNm = personName[0].LAST_NM;
        this.internalReviewData.address1 = personAddress[0].STREET_1_AD;
        this.internalReviewData.address2 = personAddress[0].STREET_2_AD;
        this.internalReviewData.city = personAddress[0].CITY_NM;
        this.internalReviewData.state = personAddress[0].STATE_CD;
        this.internalReviewData.zip = personAddress[0].ZIP_POSTAL_CD;
        this.internalReviewData.country = personAddress[0].COUNTRY_CD;
        this.internalReviewData.organization = request[0].ORGANIZATION_NM;
        this.internalReviewData.reqAccommFl = request[0].REQ_TYP_ACCOM_FL;
        this.internalReviewData.reqSupportFl = request[0].REQ_TYP_ELL_SUPP_FL;
        this.internalReviewData.recAccInSch = request[0].RECV_ACCOMM_IN_SCH;
        this.internalReviewData.testId = request[0].TEST_ID;
        this.internalReviewData.testDateId = request[0].TEST_DATE_ID;
        this.requestStatusCode = request[0].REQUEST_STATUS_CODE_ID;
        this.reviewDetails = reviewDetailId;
        this.reviewDetailId = (reviewDetailId as any[]).length
          ? reviewDetailId[0].REVIEW_DETAIL_ID
          : "";
        this.status_cd = (reviewDetailId as any[]).length
          ? reviewDetailId[0].STATUS_CD
          : "";
        this.optedAssociatedDates = personTestAdmin;
        this.personPlanId = personPlan;
        this.consultantDetails = consultantDetails[0];
        this.personRequestService.setOrg(request[0]);
        this.diagId = personDisability;
        this.documentList = personDocument;
        this.commentList = requestCommentData;
        this.reqAccoms = accommodation;
        this.internalReviewData.personName =
          this.internalReviewData.firstNm +
          " " +
          this.internalReviewData.middleNm +
          " " +
          this.internalReviewData.lastNm;
        this.studentDetails = {
          personId: this.personId,
          requestId: this.requestId,
          taaPin: this.internalReviewData.taaPin,
          personName: this.internalReviewData.personName,
          reviewDetailId: this.reviewDetailId,
          logId: this.logId
        };
        this.logDetails = logId;
        this.buildTest();
      }
    );
  }

  buildTest() {
    Observable.forkJoin([
      this.personRequestService.getTestNameByTestId(
        this.internalReviewData.testId
      ),
      this.personRequestService.getTestDateName(
        this.internalReviewData.testDateId
      ),
      this.personRequestService.getRequestStatusCodeById(
        this.requestStatusCode
      ),
      this.personRequestService.getReviewDetailId(this.personId)
    ]).subscribe(([test, testDate, rss, res]) => {
      this.internalReviewData.testName = test[0].TEST_NM;
      this.internalReviewData.testDateName = testDate[0].TEST_DATE_NM;
      this.statusCd = rss[0].STATUS_CD;
      this.reviewDetailId = (res as any[]).length
        ? res[0].REVIEW_DETAIL_ID
        : "";
    });
    this.buildDisability();
  }

  buildDisability() {
    if (this.diagId.length > 0) {
      this.diagId.forEach(item => {
        let otherExists = false;
        if (!item.OTHER_DS) {
          otherExists = true;
        }
        const data: any = {};
        Observable.forkJoin(
          this.personRequestService.getDisabilitiesName(item.DISABILITY_ID)
        ).subscribe(([response]) => {
          if (response) {
            this.autoApprovalRequestObj.disabilities.push(
              response.body[0].DISABILITY_NM
            );
            Observable.forkJoin(
              this.personRequestService.getDisabilitiesCategoryName(
                response.body[0].DISABILITY_CATEGORY_ID
              )
            ).subscribe(([result]) => {
              data.DISABILITY_CATEGORY_NM =
                result.body[0].DISABILITY_CATEGORY_NM;
              let isAvailable = false;
              this.internalReviewData.disabilityCategory.forEach(element => {
                if (
                  element.DISABILITY_CATEGORY_NM === data.DISABILITY_CATEGORY_NM
                ) {
                  if (!element.DISABILITY_NAME) {
                    element.DISABILITY_NAME = [];
                  }
                  if (!otherExists) {
                    element.DISABILITY_NAME.push(item.OTHER_DS);
                  } else {
                    element.DISABILITY_NAME.push(
                      response.body[0].DISABILITY_DS
                    );
                  }
                  isAvailable = true;
                }
              });
              if (!isAvailable) {
                if (!data.DISABILITY_NAME) {
                  data.DISABILITY_NAME = [];
                }
                if (!otherExists) {
                  data.DISABILITY_NAME.push(item.OTHER_DS);
                } else {
                  data.DISABILITY_NAME = [response.body[0].DISABILITY_DS];
                }
                this.internalReviewData.disabilityCategory.push(data);
              }
            });
          }
        });
      });
    }
    this.buildPlan();
  }

  buildPlan() {
    if (this.personPlanId.length > 0) {
      this.personPlanId.forEach(item => {
        Observable.forkJoin(
          this.personRequestService.getPlanById(item.PLAN_ID)
        ).subscribe(([plan]) => {
          if (plan[0].PLAN_NM !== "ELLPLAN") {
            this.disPlan = true;
            this.displayPlanName = true;
            this.internalReviewData.planName = plan[0].PLAN_NM;
            if (item.YEARS_ON_PLAN_NO === "=>4") {
              this.internalReviewData.lengthDisplay = "4 Months or More";
              this.autoApprovalRequestObj.planLength = "M";
            } else if (item.YEARS_ON_PLAN_NO === "<4") {
              this.internalReviewData.lengthDisplay = "Less Than 4 Months";
              this.autoApprovalRequestObj.planLength = "N";
            } else if (item.YEARS_ON_PLAN_NO === "=>1") {
              this.internalReviewData.lengthDisplay =
                "Twelve Calendar Months or More";
              this.autoApprovalRequestObj.planLength = "G";
            } else if (item.YEARS_ON_PLAN_NO === "<1") {
              this.internalReviewData.lengthDisplay =
                "Less Than Twelve Calendar Months";
              this.autoApprovalRequestObj.planLength = "L";
            } else {
              this.internalReviewData.lengthDisplay = "NA";
              this.autoApprovalRequestObj.planLength = "NA";
            }
          }
          if (plan[0].PLAN_NM === "ELLPLAN") {
            this.supReason = true;
            if (item.RECV_ELL_SUPP_IN_SCH === "Y") {
              // set display to Yes
              this.internalReviewData.supDisplay = "Yes";
            } else {
              // set display to No
              this.internalReviewData.supDisplay = "No";
            }
            this.autoApprovalRequestObj.planLength = "NA";
          }
        });
      });
    }
    this.buildAccoms();
  }

  buildAccoms() {
    if (this.reqAccoms.length > 0) {
      this.reqAccoms.forEach(item => {
        let otherExists = false;
        if (item.OTHER_DS) {
          item.OTHER_DS = "OTHER : " + item.OTHER_DS;
        }
        if (!item.OTHER_DS) {
          otherExists = true;
        }
        this.autoApprovalRequestObj.accomsList.push(item);
        Observable.forkJoin(
          this.personRequestService.getAccomsName(item.ACCOMMODATION_ID)
        ).subscribe(([response]) => {
          const data: any = {};
          if (response) {
            Observable.forkJoin(
              this.personRequestService.getAccomsCategoryName(
                response.body[0].ACCOMMODATION_CATEGORY_ID
              )
            ).subscribe(([result]) => {
              data.ACCOMMODATION_CATEGORY_NM =
                result.body[0].ACCOMMODATION_CATEGORY_DS;
              let isAvailable = false;

              this.internalReviewData.displayAccomsList.forEach(element => {
                if (
                  element.ACCOMMODATION_CATEGORY_NM ===
                  data.ACCOMMODATION_CATEGORY_NM
                ) {
                  if (!element.ACCOMMODATION_DS) {
                    element.ACCOMMODATION_DS = [];
                  }
                  if (!otherExists) {
                    if (item.STATUS_CD === "P") {
                      element.ACCOMMODATION_DS.push(
                        "Previous Other:" + item.OTHER_DS
                      );
                    } else {
                      element.ACCOMMODATION_DS.push(item.OTHER_DS);
                    }
                  } else {
                    element.ACCOMMODATION_DS.push(
                      response.body[0].ACCOMMODATION_DS
                    );
                  }
                  isAvailable = true;
                }
              });

              if (!isAvailable) {
                if (!data.ACCOMMODATION_DS) {
                  data.ACCOMMODATION_DS = [];
                }
                if (!otherExists) {
                  if (item.STATUS_CD === "P") {
                    data.ACCOMMODATION_DS.push([
                      "Previous Other:" + item.OTHER_DS
                    ]);
                  } else {
                    data.ACCOMMODATION_DS.push([item.OTHER_DS]);
                  }
                } else {
                  data.ACCOMMODATION_DS = [response.body[0].ACCOMMODATION_DS];
                }
                this.internalReviewData.displayAccomsList.push(data);
              }
            });
          }
        });
      });
    }

    this.buildDocumentList();
  }

  buildDocumentList() {
    if (this.documentList.length > 0) {
      this.documentList.forEach(item => {
        Observable.forkJoin(
          this.personRequestService.getDocumentTypeById(item.DOCUMENT_TYPE_ID)
        ).subscribe(([response]) => {
          const data: any = {};
          this.autoApprovalRequestObj.documents.push(
            response.body[0].DOCUMENT_TYPE_NM
          );
          data.DOCUMENT_TYPE_DS = response.body[0].DOCUMENT_TYPE_DS;
          data.DISPLAY_ORDER_NO = response.body[0].DISPLAY_ORDER_NO;
          data.FILE_NM = item.FILE_NM;
          data.CREATED_ON_DT = item.CREATED_ON_DT;
          data.MIGRATED_FL = item.MIGRATED_FL;
          data.PERSON_ID = item.PERSON_ID;
          data.CMS_ENC_KEY = item.CMS_ENC_KEY;
          data.CMS_DOCUMENT_ID = item.CMS_DOCUMENT_ID;
          data.PERSON_DOCUMENT_ID = item.PERSON_DOCUMENT_ID;
          data.LOCKED_FL = item.LOCKED_FL;
          this.internalReviewData.documentDisplayList.push(data);
          this.internalReviewData.documentDisplayList.sort((a, b) => {
            return a.DISPLAY_ORDER_NO - b.DISPLAY_ORDER_NO;
          });
        });
      });
    }

    this.buildCommentList();
  }

  downloadDecisionFile(event, item: any, fileName: any) {
    console.log("Migrated Fl of : " + item.FILE_NM + " " + item.MIGRATED_FL);
    const data = {
      fileName: fileName,
      PERSON_ID: item.PERSON_ID,
      REQUEST_ID: item.REQUEST_ID,
      REVIEW_DETAIL_ID: item.REVIEW_DETAIL_ID
    };
    this.documentService.downloadFile(data);

    event.stopPropagation();
    event.preventDefault();
  }

  buildCommentList() {
    this.internalReviewData.commentList = this.commentList.body;

    if (this.reviewDetailId !== "") {
      this.buildReviewDetails();
    }
  }

  buildReviewDetails() {
    this.analystsService
      .getConsultantDetailsById(this.reviewDetails[0].CONSULTANT_ID)
      .subscribe(
        data => {
          this.reviewConsultantDetails = data[0];
        },
        err => {}
      );
    if (this.reviewDetails.length > 0) {
      this.reviewDetails.forEach(item => {
        if (item.EXAMINEE_ACCOMMS) {
          item.EXAMINEE_ACCOMMS = item.EXAMINEE_ACCOMMS.replace(/\|/g, ",");
        }
      });
    }
  }

  saveComments() {
    const requestComment = {
      UPDATED_BY_DS: this.userProfile.loggedInUser,
      REQUEST_ID: this.requestId,
      COMMENT_TEXT: this.commentText,
      COMMENT_TYPE_CD: "ACCMGR"
    };

    if (this.commentText !== "") {
      this.viewComment = false;
      this.commentTextError = !this.regexTest(this.commentText, 500);
      if (this.commentTextError) {
        return;
      }
      this.personRequestService
        .createRequestComment(requestComment)
        .subscribe(comment => {
          if (comment) {
            this.personRequestService
              .getRequestCommentsById(this.requestId)
              .subscribe(commentList => {
                const temp: any = commentList;
                this.internalReviewData.commentList = temp.body;
                this.viewComment = true;
              });
          }
        });
      this.commentText = undefined;
    }
  }

  regexTest(str, length) {
    if (_.isEmpty(_.toString(str))) {
      return false;
    }
    if (str.length > length) {
      return false;
    }
    const pattern = /^[a-zA-Z0-9\.\s\,\:\;]{1,500}$/;
    const regex = new RegExp(pattern);
    return regex.test(str);
  }

  startReview() {
    Observable.forkJoin(
      this.requestSubmitService.getRequestStatusCodeIdByNm(
        this.taaConstants.getINREVIEW()
      )
    ).subscribe(([assigned]) => {
      this.requestStatusId = assigned;
      const statusChangeData = {
        UPDATED_BY_DS: this.userProfile.loggedInUser,
        REQUEST_STATUS_CODE_ID: this.requestStatusId[0].REQUEST_STATUS_CODE_ID,
        PERSON_ID: this.personId,
        REQUEST_ID: this.requestId
      };

      this.personRequestService
        .updateRequestStatus(statusChangeData)
        .subscribe(success => {
          if (this.reviewDetailId !== undefined) {
            sessionStorage.setItem(
              "reviewDetailId",
              JSON.stringify(this.reviewDetailId)
            );
          }
          sessionStorage.setItem("requestId", JSON.stringify(this.requestId));
          sessionStorage.setItem("status_cd", JSON.stringify(this.status_cd));
          this.router.navigate(["accommsSupport"]);
        });
    });
  }

  toBack() {
    this.router.navigate(["intsuplanding"]);
  }

  edit() {
    this.router.navigate(["editExaminee"]);
  }

  downloadFile(event, item: any, fileName: any) {
    console.log("Migrated Fl of : " + item.FILE_NM + " " + item.MIGRATED_FL);
    this.personRequestService.downloadFile(
      fileName,
      this.personId,
      this.requestId
    );

    event.stopPropagation();
    event.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/examinee-request-details/examinee-request-details.component.ts